// ════════════════════════════════════════════════════════════
//  online/rows.js — a finished bout → its ledger row (PURE)
// ════════════════════════════════════════════════════════════
//  Lived in keeper.js; moved here so stage.js can build the same row for the
//  hour on air (the early lock, 2026-10-17) without keeper.js ↔ stage.js
//  importing each other. keeper.js still re-exports rowOf.
// ════════════════════════════════════════════════════════════
import { weekOf } from "./circuit.js";

/** A finished bout → its ledger row (first write wins). */
export function rowOf(f, info) {
  if (f.phase !== "done" || (f.winner !== 0 && f.winner !== 1) || !f.A || !f.B) return null;
  // a GUEST's bout (2026-10-20, retired 2026-10-21) was an exhibition: it never touched the table. A CHALLENGER's counts ("once you join you're official")
  if (f.A.home === "guest" || f.B.home === "guest") return null;
  const tag = {};
  for (const x of ["dv", "fx", "c", "r", "i", "g", "ln"]) if (f[x] != null) tag[x] = f[x];
  return {
    id: f.id, week: weekOf(f.startAt), kind: f.k, ...tag, hk: info.kind, h: info.h, j: f.j,
    a: f.A.key, b: f.B.key, w: f.winner, t: Math.round(((f.endAt || f.startAt) - f.startAt) / 1000),
    up: f.up || null, an: f.an || null, why: f.why || null, by: f.by || null, at: f.startAt,
    ...bookOf(f.A, "a"), ...bookOf(f.B, "b"),
  };
}
// THE MIND: the playbook each side fought with — sa/ta/ca, sb/tb/cb (only what's there: Firebase refuses undefined)
const bookOf = (E, x) => ({
  ...(E && E.style ? { [`s${x}`]: E.style } : {}),
  ...(E && E.style && Array.isArray(E.team) ? { [`t${x}`]: E.team.slice() } : {}),
  ...(E && E.change ? { [`c${x}`]: E.change } : {}),
});
